import React from "react";
import _ from "lodash";
import styled from "styled-components";

import PerformanceComponent from "./performance";
import Chart from "./chart";
import Auth from "routes/Auth";

import Teams from "api/Teams";

import { getRequest } from "api/ApiService";
import moment from "moment";
import get from "lodash/get";

import PeerEvaluation from "../peer-evaluation";
import IconLock from "../../containers/assets/icon-lock.svg";

import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Legend,
} from 'recharts';
import cn from 'classnames';

// profile components
const Profile = {};

Profile.Wrapper = styled.section`
  width: 100%;
  padding: 20px 40px !important;
  max-width: 1180px;
  background-color: hsla(0, 0%, 98%, 1);
  box-sizing: content-box;
`;

Profile.CardWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

Profile.Title = styled.div`
  font-family: Lato;
  font-size: 21px;
  font-weight: 600;
  color: lightgray;

  ${p =>
    p.marginTop &&
    `
    margin-top: ${p.marginTop};
  `}
`;

// evaluation form components
const EvaluationForm = {};

EvaluationForm.Wrapper = styled.div`
  padding: 30px 0;
  display: flex;
  align-items: center;
`;

EvaluationForm.Circle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 30px;
  margin-right: 15px;

  ${p =>
    p.background &&
    `
    background: ${p.background};
  `}
`;

EvaluationForm.Title = styled.div`
  font-family: Lato;
  font-size: 24px;
  font-weight: 700;
  color: #5f5f5f;
`;

// performance components
const Performance = {};

Performance.Wrapper = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 20px;
  background-color: hsla(0, 0%, 100%, 1);
  border: 1px solid hsla(213, 100%, 12%, 0.15);
  border-radius: 8px;
`;

Performance.Title = styled.div`
  font-family: "Mukta Vaani", sans-serif;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: hsla(213, 100%, 12%, 0.94);
`;

Performance.Menu = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  border-bottom: 1px solid hsla(213, 100%, 12%, 0.15);
`;

const LockScreen = {};
LockScreen.Wrapper = styled.div`
  height: 550px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
  padding: 20px;
  background-color: hsla(0, 0%, 100%, 1);
  border: 1px solid hsla(213, 100%, 12%, 0.15);
  border-radius: 8px;
`;
LockScreen.Text = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #3A507B;
  margin-top: 18px;
`;

// table components

const Table = {};

Table.Wrapper = styled.div`
  background: #fff;
  margin-top: 20px;
  width: 100%;
  max-height: 450px;
  position: relative;
  z-index: 1;
`;

Table.Row = styled.div`
  display: flex;
  width: 100%;
  padding: 0 20px;

  ${p =>
    p.background &&
    `
    background: ${p.background};
  `}
  img {
    cursor: pointer;
  }
`;

Table.Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-family: "Mukta Vaani", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  color: hsla(213, 100%, 12%, 0.94);
  padding: 15px 20px;

  ${p =>
    p.align &&
    `
    text-align: ${p.align};
  `}
  ${p =>
    p.width &&
    `
    flex: 0 0 ${p.width};
  `}

  ${p =>
    p.isValue &&
    `
    font-weight: 500;
  `}
`;

// charts components
const Charts = {};

Charts.Wrapper = styled.div`
  background: #fff;
  margin-top: 20px;
  width: 100%;
  z-index: 1;

  ${p =>
    p.setMaxHeight &&
    `
    max-height: 450px;
  `}
`;

Charts.Teams = {};

Charts.Teams.Wrapper = styled.div`
  display: flex;
  padding-top: 30px;
  padding-bottom: 20px;
  color: #36507e;
  font-weight: 600;
  font-size: 15px;
`;

Charts.Teams.Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  ${p =>
    p.margin &&
    `
    margin: ${p.margin};
  `}
`;

Charts.Teams.TeamColor = styled.div`
  height: 10px;
  width: 40px;
  margin-right: 10px;

  ${p =>
    p.background &&
    `
    background: ${p.background};
  `}
`;

Charts.Teams.TeamName = styled.div`
  font-size: 14px;
  color: #36507e;
`;

Charts.Chart = styled.div`
  width: 100%;
`;

const SkillsAssessment = {};

SkillsAssessment.Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  gap: 20px;
`;

SkillsAssessment.InfoTitle = styled.div`
  font-family: "Mukta Vaani", sans-serif;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  margin-top: 20px;
  color: rgba(0, 27, 59, 0.94);
`;

SkillsAssessment.InfoBody = styled.div`
  font-family: "Mukta Vaani", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin-top: 8px;
  color: rgba(0, 27, 59, 0.94);
`;

SkillsAssessment.TagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

SkillsAssessment.Tag = styled.div`
  font-family: "Mukta Vaani", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  padding: 1px 8px;
  border-radius: 2px;
  border: 1px solid rgba(0, 27, 59, 0.15);
  color: #5c91f5;
`;

SkillsAssessment.TagTitle = styled.div`
  font-family: "Mukta Vaani", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: rgba(0, 27, 59, 0.6);
`;

SkillsAssessment.SkillsMap = styled.div``;

SkillsAssessment.SkillsMapTitle = styled.div`
  font-family: "Mukta Vaani", sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

SkillsAssessment.SkillsMapBody = styled.div`
  font-family: "Mukta Vaani", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 8px;
`;

SkillsAssessment.MintSection = styled.div`
  margin-top: 16px;
  padding: 20px;
  border: 1px solid #6fd1d9;
  background: rgba(82, 197, 205, 0.5);
  border-radius: 4px;
`;

SkillsAssessment.OrangeSection = styled.div`
  margin-top: 16px;
  padding: 20px;
  border: 1px solid #fd9595;
  background: rgba(255, 153, 102, 0.5);
  border-radius: 4px;
`;

SkillsAssessment.ColorSectionTitle = styled.div`
  font-family: "Mukta Vaani", sans-serif;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: #2a4169;
`;

SkillsAssessment.ColorSectionBody = styled.div`
  margin-top: 16px;
  font-family: "Mukta Vaani", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

SkillsAssessment.ColorSectionTags = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;

SkillsAssessment.ColorSectionTag = styled.div`
  padding: 1px 8px;
  background: #fff;
  border: 1.5px solid #2a4169;
  border-radius: 4px;
  font-family: "Mukta Vaani", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: #2a4169;
`;

SkillsAssessment.ChartDescription = styled.div`
  max-width: 560px;
  margin-top: 20px;
  font-family: "Mukta Vaani", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);

  b {
    font-weight: 700;
  }
`;

SkillsAssessment.RadarChartWrapper = styled.div`
  background: rgba(0, 27, 43, 0.02);

  .recharts-legend-item-text {
    font-family: "Mukta Vaani", sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 27, 59, 0.94);
  }

  .recharts-default-legend {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    gap: 20px;
  }

  .recharts-legend-item {
    display: block !important;
    margin: 0 !important;

    svg {
      margin-right: 12px !important;

      line {
        stroke-width: 2;
      }
    }
  }

  .recharts-polar-angle-axis-tick-value {
    font-family: "Mukta Vaani", sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    fill: rgba(0, 27, 59, 0.6);

    &:hover, &.recharts-polar-angle-axis-tick-value-selected {
      font-weight: 700;
      fill: rgba(0, 27, 59, 0.94);
      cursor: pointer;
    }
  }

  .recharts-polar-angle-axis-ticks {
    transform: translateY(5px);
  }
`;

export default class PeerReview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      performance: [
        { id: 1, name: "Peer Rating", isActive: true },
      ],
      surveys: [],
      reports: {},
      grading: {},
      teamGrade: 0,
      currentScore: {},
      userGrade: {},
      skillsAssessmentCalculated: false,
      skillsAssessmentRating: [],
      skillsAssessmentTooltip: null,
      skillsAssessmentDefinitions: {},
      peerScoreValue: null,
      showPerformanceSummary: false
    };
  }

  getSkillsAssessmentDefinitions = survey => {
    let definitions = [];

    for (const question of survey.questions) {
      definitions = definitions.concat(question.statements);
    }

    return definitions
      .map(d => d.student_category || null)
      .filter(d => !!d)
      .reduce((obj, item) => {
        return {
          ...obj,
          [item.name]: item.definition,
        };
      }, {});
  }

  async componentDidMount() {
    const surveysRaw = await getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/surveys/`
    );
    const surveys = surveysRaw.body.results;

    const finishedSurveys =
      surveys && surveys.length > 0
        ? surveys.filter(i => this.isSurveyFinished(i))
        : [];
    const lastSurveyId =
      finishedSurveys.length > 0
        ? finishedSurveys[finishedSurveys.length - 1].id
        : 0;

    if (surveys.length > 0) {
      let skillsAssessmentCalculated = false;
      const skillsAssessmentRating = [];
      const performance = [
        ...this.state.performance,
      ];
      let skillsAssessmentDefinitions = {};

      const initialSurvey = surveys.find(i => i.stage === 'initial');
      let initialSurveyExists = false;
      if (initialSurvey && initialSurvey.questions) {
        const skillsQuestions = initialSurvey.questions.filter(i => ['other', 'skills'].includes(i.category) && i.answer_type === 'freeform');
        if (skillsQuestions.length > 0) {
          initialSurveyExists = true;
          skillsAssessmentDefinitions = this.getSkillsAssessmentDefinitions(initialSurvey);

          try {
            const { body } = await getRequest(
              `${process.env.REACT_APP_API_URL}v2/forms/skills-assessment/${initialSurvey.id}/student/${Auth.getUserId()}/`
            );
            if (body) {
              skillsAssessmentRating.push(body);
              skillsAssessmentCalculated = Object.values(body).some(i => i > 0);
            }
          } catch (e) {
            initialSurveyExists = false;
          }
        }
      }

      if (initialSurveyExists) {
        const secondSurvey = surveys.find(i => i.stage === 'second');
        if (secondSurvey && secondSurvey.questions) {
          const skillsQuestions = secondSurvey.questions.filter(i => ['other', 'skills'].includes(i.category) && i.answer_type === 'freeform');
          if (skillsQuestions.length > 0) {
            skillsAssessmentDefinitions = this.getSkillsAssessmentDefinitions(secondSurvey);

            try {
              const { body } = await getRequest(
                `${process.env.REACT_APP_API_URL}v2/forms/skills-assessment/${secondSurvey.id}/student/${Auth.getUserId()}/`
              );
              if (body && Object.values(body).some(i => i > 0)) {
                skillsAssessmentRating.push(body);
                if (!skillsAssessmentCalculated) {
                  skillsAssessmentCalculated = Object.values(body).some(i => i > 0);
                }
              }
            } catch (e) {
              // do nothing
            }
          }
        }

        const finalSurvey = surveys.find(i => i.stage === 'final');
        if (finalSurvey && finalSurvey.questions) {
          const skillsQuestions = finalSurvey.questions.filter(i => ['other', 'skills'].includes(i.category) && i.answer_type === 'freeform');
          if (skillsQuestions.length > 0) {
            skillsAssessmentDefinitions = this.getSkillsAssessmentDefinitions(finalSurvey);

            try {
              const { body } = await getRequest(
                `${process.env.REACT_APP_API_URL}v2/forms/skills-assessment/${finalSurvey.id}/student/${Auth.getUserId()}/`
              );
              if (body && Object.values(body).some(i => i > 0)) {
                skillsAssessmentRating.push(body);
                if (!skillsAssessmentCalculated) {
                  skillsAssessmentCalculated = Object.values(body).some(i => i > 0);
                }
              }
            } catch (e) {
              // do nothing
            }
          }
        }
      }

      if (initialSurveyExists) {
        performance.push({ id: 3, name: 'Skills Assessment', isActive: false });
      }

      const formsFeedbacksRaw = await getRequest(
        `${process.env.REACT_APP_API_URL}v2/forms/feedbacks/`
      );
      const formsFeedbacks = formsFeedbacksRaw.body.results;
      let allFeedbacksCompleted = true;
      finishedSurveys.forEach(finishedSurvey => {
        const notCompletedSurveyFormsFeedbacks = formsFeedbacks.filter(formsFeedback => formsFeedback.survey === finishedSurvey.id && formsFeedback.completed !== true);
        if (notCompletedSurveyFormsFeedbacks.length) {
          allFeedbacksCompleted = false;
          return;
        }
      });

      this.setState({
        performance,
        skillsAssessmentCalculated,
        skillsAssessmentRating,
        skillsAssessmentDefinitions,
        showPerformanceSummary: allFeedbacksCompleted || finishedSurveys.length
      });
    }

    if (lastSurveyId > 0) {
      try {
        const { body: currentScore } = await getRequest(
          `${process.env.REACT_APP_API_URL
          }v2/forms/score/${Auth.getUserId()}/${lastSurveyId}/`
        );

        this.setState({
          currentScore
        });
      } catch (e) {
        const errorDetail = get(e, 'response.body.detail', null);
        if (errorDetail === 'Not found.') {
          this.setState({
            currentScore: {},
          });
        }
      }
    }

    const { rounds } = this.props;
    const maxRoundNumber = Math.max.apply(
      null,
      rounds.map(round => round.number)
    );
    const latestCompletedRound = Math.max.apply(
      null,
      rounds.filter(round => round.is_finished).map(round => round.number)
    );
    const latestCompletedRoundObj = rounds.find(
      i => i.number === latestCompletedRound
    );
    let latestCompletedRoundId = 0;
    if (latestCompletedRoundObj) {
      latestCompletedRoundId = latestCompletedRoundObj.id;
    }

    if (lastSurveyId > 0 && latestCompletedRoundId > 0) {
      try {
        const { body: userGrade } = await getRequest(
          `${process.env.REACT_APP_API_URL
          }v2/games/usergrade/${lastSurveyId}/${latestCompletedRoundId}/${Auth.getUserId()}/`
        );

        this.setState({
          userGrade
        });
      } catch (e) {
        const errorDetail = get(e, 'response.body.detail', null);
        if (errorDetail === 'Not found.') {
          this.setState({
            userGrade: {},
          });
        }
      }

      await this.getPeerScoreValue(latestCompletedRoundId, lastSurveyId);
    }

    const { body: gradingData } = await getRequest(
      `${process.env.REACT_APP_API_URL}team/grading/?round_lte=${maxRoundNumber}`
    );
    let grading = {};
    gradingData.forEach(data => {
      grading[data.round_number] = data.current_weighted_value;
    });
    let teamGrade = 0;
    const completedRound = gradingData.find(
      i => i.round_number === latestCompletedRound
    );
    if (completedRound) {
      teamGrade = completedRound.weighted_value;
    }

    const showSkillsAssessmentTab = surveys.some(survey =>
      survey.questions.some(
        question => question.category === "skills_assessment"
      )
    );

    this.setState(
      prevState => ({
        surveys,
        grading,
        teamGrade,
        performance: showSkillsAssessmentTab
          ? [
            ...prevState.performance,
            { id: 3, name: "Skills Assessment", isActive: false }
          ]
          : prevState.performance
      }),
      () => {
        surveys.forEach(survey => {
          if (this.isSurveyFinished(survey)) {
            this.loadReport(survey, Auth.getUserId());
          }
        });
      }
    );
  }

  get peerScoreValue() {
    const { peerScoreValue } = this.state;

    return peerScoreValue === null
      ? '---'
      : `${(peerScoreValue * 100).toFixed(2)}%`;
  }

  async getPeerScoreValue(roundId, surveyId) {
    const userId = Number(this.getCurrentUserId());

    try {
      const res = await getRequest(
        `${process.env.REACT_APP_API_URL}v2/games/usergrade/${surveyId}/${roundId}/${userId}/`
      );
      const { peer_adjustment_grade } = res.body;

      this.setState({
        peerScoreValue: Number(peer_adjustment_grade),
      });
    } catch (err) {
      this.setState({
        peerScoreValue: null,
      });
      console.log('Cannot get peer score data', err);
    }
  }

  get gradingValue() {
    const { userGrade, teamGrade } = this.state;
    const curved_adjusted_cumulative_value = get(
      userGrade,
      "curved_adjusted_cumulative_value",
      0
    );
    const adjusted_cumulative_value = get(
      userGrade,
      "adjusted_cumulative_value",
      0
    );

    let result = 0;
    if (curved_adjusted_cumulative_value > 0) {
      result = curved_adjusted_cumulative_value;
    } else if (adjusted_cumulative_value > 0) {
      result = adjusted_cumulative_value;
    } else if (teamGrade > 0) {
      result = teamGrade;
    }

    return result !== 0 ? `${(result * 100).toFixed(2)}%` : "-----";
  }

  isSurveyFinished = survey => {
    const surveyEndDate = moment(survey.end);
    const currentDate = moment.utc();

    return currentDate.isAfter(surveyEndDate);
  };

  loadReport = async ({ id: survey_id, stage }, receiver_id) => {
    if (survey_id && Number(survey_id) > 0) {
      try {
        const { body: report } = await getRequest(
          `${process.env.REACT_APP_API_URL}v2/forms/score/${receiver_id}/${survey_id}/`
        );
        const { reports } = this.state;

        this.setState({
          reports: {
            ...reports,
            [stage]: report
          }
        });
      } catch (e) {
        // do nothing
      }
    }
  };

  handleShowTab = id => {
    const performance = this.state.performance.map(tab =>
      tab.id === id ? { ...tab, isActive: true } : { ...tab, isActive: false }
    );

    this.setState({
      performance
    });
  };

  get latestCompletedFormValue() {
    const { reports } = this.state;
    let key = "";

    if ("initial" in reports) {
      key = "initial";
    }

    if ("second" in reports) {
      key = "second";
    }

    if ("final" in reports) {
      key = "final";
    }

    return key === ""
      ? "---"
      : _.get(reports[key], "average_user_score", 0).toFixed(2);
  }

  get latestCompletedFormKey() {
    const { reports } = this.state;
    let key = "";

    if ("initial" in reports) {
      key = "initial";
    }

    if ("second" in reports) {
      key = "second";
    }

    if ("final" in reports) {
      key = "final";
    }

    return key;
  }

  getGradingValue = (number, is_finished) => {
    const { grading } = this.state;

    if (is_finished === true && number in grading) {
      return `${(grading[number] * 100).toFixed(2)}%`;
    }

    return "-----";
  };

  get peerAdjustment() {
    const { currentScore } = this.state;
    const average_user_score = get(currentScore, "average_user_score", 0);
    const team_median_score = get(currentScore, "team_median_score", 0);
    const result =
      average_user_score < 6
        ? team_median_score !== 0
          ? Math.min(1, average_user_score / Math.max(team_median_score, 6))
          : 0
        : 1;

    return result !== 0 ? `${(result * 100).toFixed(2)}%` : "-----";
  }

  get individualGrade() {
    const { userGrade } = this.state;
    const result = get(userGrade, "adjusted_cumulative_value", 0);

    return result !== 0 ? `${(result * 100).toFixed(2)}%` : "-----";
  }

  get finalGrade() {
    const { userGrade } = this.state;
    const result = get(userGrade, "curved_adjusted_cumulative_value", 0);

    return result !== 0 ? `${(result * 100).toFixed(2)}%` : "-----";
  }

  skillsAssessmentDescription = (showSkillsAssessmentData) => {
    return showSkillsAssessmentData === true ? 'view results' : '---';
  }

  skillsAssessmentStrengthsCategories = (key) => {
    const { skillsAssessmentRating } = this.state;

    if (key === '') {
      return [];
    }

    if (key === 'initial') {
      return skillsAssessmentRating.length > 0
        ? Object.entries(skillsAssessmentRating[0]).filter(i => i[1] >= 0.7).map(i => i[0])
        : [];
    }

    if (key === 'second') {
      return skillsAssessmentRating.length > 1
        ? Object.entries(skillsAssessmentRating[1]).filter(i => i[1] >= 0.7).map(i => i[0])
        : [];
    }

    return skillsAssessmentRating.length > 2
      ? Object.entries(skillsAssessmentRating[2]).filter(i => i[1] >= 0.7).map(i => i[0])
      : [];
  }

  skillsAssessmentAreasOfDevelopmentCategories = (key) => {
    const { skillsAssessmentRating } = this.state;

    if (key === '') {
      return [];
    }

    if (key === 'initial') {
      return skillsAssessmentRating.length > 0
        ? Object.entries(skillsAssessmentRating[0]).filter(i => i[1] <= 0.3).map(i => i[0])
        : [];
    }

    if (key === 'second') {
      return skillsAssessmentRating.length > 1
        ? Object.entries(skillsAssessmentRating[1]).filter(i => i[1] <= 0.3).map(i => i[0])
        : [];
    }

    return skillsAssessmentRating.length > 2
      ? Object.entries(skillsAssessmentRating[2]).filter(i => i[1] <= 0.3).map(i => i[0])
      : [];
  }

  sortSurveys = surveys => {
    let endedSurveys = [];
    let openedSurveys = [];

    surveys.forEach(survey => {
      if (this.isSurveyEnded(survey)) {
        endedSurveys = [survey, ...endedSurveys];
      } else {
        openedSurveys = [...openedSurveys, survey];
      }
    });

    return [...openedSurveys, ...endedSurveys];
  };

  isSurveyEnded = survey => {
    const endDate = moment(survey.end);
    const currentDate = moment.utc();

    return currentDate.isSameOrAfter(endDate);
  };

  getCurrentUserId = () => {
    return Auth.getUserId();
  };

  skillsAssessmentChartData = (showSkillsAssessmentData) => {
    const { skillsAssessmentRating } = this.state;
    const result = [];
    let hasSecond = false;
    let hasFinal = false;
    const defaultData = {
      Organized: 0.7,
      Communicative: 0.75,
      Creative: 0.57,
      Inquisitive: 0.3,
      Accountable: 0.48,
      Analytical: 0.38,
      Decisive: 0.63,
      Supportive: 0.9,
    };

    if (skillsAssessmentRating && skillsAssessmentRating.length > 0) {
      const categories = [];
      for (const data of skillsAssessmentRating) {
        for (const category of Object.keys(data).filter(c => c.toLowerCase() !== 'not applicable')) {
          if (!categories.includes(category)) {
            categories.push(category);
            const value = {
              category,
              initial: showSkillsAssessmentData ? get(skillsAssessmentRating, `0.${category}`, 0) : get(defaultData, category, 0),
              second: get(skillsAssessmentRating, `1.${category}`, 0),
              final: get(skillsAssessmentRating, `2.${category}`, 0),
            };
            result.push(value);

            if (value.second > 0) {
              hasSecond = true;
            }

            if (value.final > 0) {
              hasFinal = true;
            }
          }
        }
      }
    }

    return {
      hasSecond,
      hasFinal,
      data: result,
    };
  }

  customRadiusTick = (showSkillsAssessmentData) => ({ radius, stroke, x, y, textAnchor, payload }) => {
    const { skillsAssessmentTooltip } = this.state;
    const radiusOffset = 10;
    const radiusCorrection = 90;
    const xCalculated = radiusOffset * Math.sin(Math.PI * 2 * (payload.coordinate - radiusCorrection) / 360);
    const yCalculated = radiusOffset * Math.cos(Math.PI * 2 * (payload.coordinate - radiusCorrection) / 360);
    const rectCorrection = Math.abs(payload.coordinate - 90);
    let rectOffsetX = 32;
    let rectOffsetY = 10;
    if (rectCorrection > 0 && rectCorrection < 180) {
      rectOffsetX = 0;
    }

    if (rectCorrection > 180) {
      rectOffsetX = 64;
    }

    return (
      <g className="recharts-layer recharts-polar-angle-axis-tick">
        {!showSkillsAssessmentData && (
          <rect
            x={x - xCalculated - rectOffsetX}
            y={y - yCalculated - rectOffsetY}
            rx="5"
            ry="5"
            width="64"
            height="9"
            style={{ fill: '#c4c4c4' }}>
          </rect>
        )}
        {showSkillsAssessmentData && (
          <text
            radius={radius}
            stroke={stroke}
            x={x - xCalculated}
            y={y - yCalculated}
            className={cn("recharts-text recharts-polar-angle-axis-tick-value", {
              'recharts-polar-angle-axis-tick-value-selected': skillsAssessmentTooltip && payload.value === skillsAssessmentTooltip.category,
            })}
            textAnchor={textAnchor}
          >
            <tspan x={x - xCalculated} dy="0em">{payload.value}</tspan>
          </text>
        )}
      </g>
    );
  }

  customTickClick = (showSkillsAssessmentData) => (data) => {
    const {
      skillsAssessmentDefinitions,
      skillsAssessmentTooltip,
    } = this.state;

    if (
      showSkillsAssessmentData === true
      && data
      && data.value
      && skillsAssessmentDefinitions[data.value]
    ) {
      if (skillsAssessmentTooltip && skillsAssessmentTooltip.category === data.value) {
        this.setState({
          skillsAssessmentTooltip: null,
        });
      } else {
        this.setState({
          skillsAssessmentTooltip: {
            category: data.value,
            text: skillsAssessmentDefinitions[data.value],
          },
        });
      }
    }
  }

  render() {
    const {
      performance,
      surveys,
      reports,
      skillsAssessmentCalculated,
      skillsAssessmentTooltip,
      showPerformanceSummary
    } = this.state;

    const isPeerRatingScoreActive = _.get(
      _.find(performance, {
        name: "Peer Rating"
      }),
      "isActive",
      false
    );

    const isSkillsAssessmentActive = _.get(
      _.find(performance, {
        name: "Skills Assessment"
      }),
      "isActive",
      false
    );

    const sortedSurveys = this.sortSurveys(surveys);
    const latestCompletedFormValue = this.latestCompletedFormValue;
    const latestCompletedFormKey = this.latestCompletedFormKey;
    const showSkillsAssessmentData = skillsAssessmentCalculated === true && ['initial', 'second', 'final'].includes(latestCompletedFormKey);
    const showSkillsAssessmentDataSecond = skillsAssessmentCalculated === true && ['second', 'final'].includes(latestCompletedFormKey);
    const showSkillsAssessmentDataFinal = skillsAssessmentCalculated === true && latestCompletedFormKey === 'final';
    const skillsAssessmentStrengthsCategories = this.skillsAssessmentStrengthsCategories(latestCompletedFormKey);
    const skillsAssessmentAreasOfDevelopmentCategories = this.skillsAssessmentAreasOfDevelopmentCategories(latestCompletedFormKey);
    const skillsAssessmentChartData = this.skillsAssessmentChartData(showSkillsAssessmentData);



    return (
      <Profile.Wrapper className="instructorPage instructorDashboard">
        <Profile.CardWrapper>
          {sortedSurveys.map(survey => (
            <PeerEvaluation key={survey.id} survey={survey} />
          ))}
        </Profile.CardWrapper>
        {
          showPerformanceSummary &&
          <Performance.Wrapper>
            <Performance.Title>Performance Summary</Performance.Title>
            <Performance.Menu>
              {performance.map((item, index) => (
                <PerformanceComponent
                  key={index}
                  handleShowTab={this.handleShowTab}
                  value={
                    item.name === "Skills Assessment"
                      ? this.skillsAssessmentDescription(showSkillsAssessmentData)
                      : item.name === "Peer Rating"
                        ? latestCompletedFormValue
                        : this.gradingValue
                  }
                  {...item}
                />
              ))}
            </Performance.Menu>
            {isPeerRatingScoreActive && (
              <Charts.Wrapper
                setMaxHeight={Object.keys(reports).length === 1 ? true : false}
              >
                <Charts.Teams.Wrapper>
                  <Charts.Teams.Row>
                    <Charts.Teams.TeamColor
                      background={Teams.currentTeamColor()}
                    />
                    <Charts.Teams.TeamName>You</Charts.Teams.TeamName>
                  </Charts.Teams.Row>
                  <Charts.Teams.Row margin="0 20px">
                    <Charts.Teams.TeamColor background="#eee" />
                    <Charts.Teams.TeamName>Team Average</Charts.Teams.TeamName>
                  </Charts.Teams.Row>
                  <Charts.Teams.Row margin="0 20px">
                    <Charts.Teams.TeamColor background="#c4c4c4" />
                    <Charts.Teams.TeamName>Team Median</Charts.Teams.TeamName>
                  </Charts.Teams.Row>
                </Charts.Teams.Wrapper>
                <Charts.Chart>
                  <Chart
                    reports={reports}
                    surveys={surveys}
                    isSurveyFinished={this.isSurveyFinished}
                    title="Collaboration"
                  />
                </Charts.Chart>
              </Charts.Wrapper>
            )}
            {isSkillsAssessmentActive && (
              <SkillsAssessment.Wrapper>
                <div>
                  <SkillsAssessment.RadarChartWrapper>
                    <RadarChart width={560} height={480} cx="50%" cy="50%" outerRadius="65%" data={skillsAssessmentChartData.data}>
                      {showSkillsAssessmentData && (
                        <Legend iconType="plainline" iconSize={40} />
                      )}
                      <PolarGrid />
                      <PolarAngleAxis dataKey="category" tick={this.customRadiusTick(showSkillsAssessmentData)} onClick={this.customTickClick(showSkillsAssessmentData)} />
                      <PolarRadiusAxis domain={[0, 1]} axisLine={false} tick={false} tickCount={6} />
                      <Radar
                        name={skillsAssessmentChartData.hasFinal && showSkillsAssessmentDataFinal
                          ? 'Skills (Initial)'
                          : 'Skills Demonstrated (Initial)'}
                        dataKey="initial"
                        stroke={showSkillsAssessmentData ? '#f9c151' : 'rgba(0, 31, 62, 0.2)'}
                        strokeWidth="2px"
                        fill={showSkillsAssessmentData ? '#fec665' : '#001f3e'}
                        fillOpacity={showSkillsAssessmentData ? 0.25 : 0.13}
                      />
                      {skillsAssessmentChartData.hasSecond && showSkillsAssessmentDataSecond && (
                        <Radar
                          name={skillsAssessmentChartData.hasFinal && showSkillsAssessmentDataFinal
                            ? 'Skills (Previous)'
                            : 'Skills Demonstrated (As of now)'}
                          dataKey="second"
                          stroke="#55b4bc"
                          strokeWidth="2px"
                          fill="#52c5cd"
                          fillOpacity={0.5}
                        />
                      )}
                      {skillsAssessmentChartData.hasFinal && showSkillsAssessmentDataFinal && (
                        <Radar
                          name="Skills (As of now)"
                          dataKey="final"
                          stroke="#a98df6"
                          strokeWidth="2px"
                          fill="#a98df6"
                          fillOpacity={0.5}
                        />
                      )}
                    </RadarChart>
                  </SkillsAssessment.RadarChartWrapper>
                  {!!skillsAssessmentTooltip && (
                    <SkillsAssessment.ChartDescription>
                      {skillsAssessmentTooltip.text}
                    </SkillsAssessment.ChartDescription>
                  )}
                </div>
                {showSkillsAssessmentData === false && (
                  <div>
                    <SkillsAssessment.TagWrapper>
                      <SkillsAssessment.Tag>Locked</SkillsAssessment.Tag>
                      <SkillsAssessment.TagTitle>
                        Complete the Peer Evaluation to unlock this section
                      </SkillsAssessment.TagTitle>
                    </SkillsAssessment.TagWrapper>
                    <SkillsAssessment.InfoTitle>
                      What would be here?
                    </SkillsAssessment.InfoTitle>
                    <SkillsAssessment.InfoBody>
                      Each invidudual is unique and can bring different things to a
                      team. The Skills Map on the left will show your{" "}
                      <b>strengths</b> and <b>areas of development</b> reflected in
                      the game by hearing from the others on your team.
                    </SkillsAssessment.InfoBody>
                    <SkillsAssessment.InfoBody>
                      Take this as a resource to further know your shining points
                      and grow with more understanding of yourself.
                    </SkillsAssessment.InfoBody>
                  </div>
                )}
                {showSkillsAssessmentData === true && (
                  <div>
                    <SkillsAssessment.SkillsMap>
                      <SkillsAssessment.SkillsMapTitle>Skills Map</SkillsAssessment.SkillsMapTitle>
                      <SkillsAssessment.SkillsMapBody>
                        The Skills Map on the left shows your interpersonal skills
                        reflected in the game as well as your classmates. Interact
                        with the map to learn more about each skill and how you can
                        develop them as your personal strength in future career.
                      </SkillsAssessment.SkillsMapBody>
                    </SkillsAssessment.SkillsMap>
                    {skillsAssessmentStrengthsCategories.length > 0 && (
                      <SkillsAssessment.MintSection>
                        <SkillsAssessment.ColorSectionTitle>My Strengths</SkillsAssessment.ColorSectionTitle>
                        <SkillsAssessment.ColorSectionBody>
                          Well done! You are demonstrating these teamwork skills at a high level.
                        </SkillsAssessment.ColorSectionBody>
                        <SkillsAssessment.ColorSectionTags>
                          {skillsAssessmentStrengthsCategories.map((category, index) => (
                            <SkillsAssessment.ColorSectionTag key={`sa-strengths-category-${index}`}>{category}</SkillsAssessment.ColorSectionTag>
                          ))}
                        </SkillsAssessment.ColorSectionTags>
                      </SkillsAssessment.MintSection>
                    )}
                    {skillsAssessmentAreasOfDevelopmentCategories.length > 0 && (
                      <SkillsAssessment.OrangeSection>
                        <SkillsAssessment.ColorSectionTitle>Areas of Development</SkillsAssessment.ColorSectionTitle>
                        <SkillsAssessment.ColorSectionBody>
                          This assessment might only be able to reflect part of you and what you're
                          good at, but here are some tips to help you shine in these areas that are
                          highly valued in workspace.
                        </SkillsAssessment.ColorSectionBody>
                        <SkillsAssessment.ColorSectionTags>
                          {skillsAssessmentAreasOfDevelopmentCategories.map((category, index) => (
                            <SkillsAssessment.ColorSectionTag key={`sa-areasofdevelopment-category-${index}`}>{category}</SkillsAssessment.ColorSectionTag>
                          ))}
                        </SkillsAssessment.ColorSectionTags>
                      </SkillsAssessment.OrangeSection>
                    )}
                  </div>
                )}
              </SkillsAssessment.Wrapper>
            )}
          </Performance.Wrapper>
        }
        {
          !showPerformanceSummary &&
          <LockScreen.Wrapper>
            <img alt="The results is locked" src={IconLock} />
            <LockScreen.Text>To unlock results, complete peer evaluation.</LockScreen.Text>
          </LockScreen.Wrapper>
        }
      </Profile.Wrapper>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/peer-review/index.js